<template>
  <b-modal
    :active.sync="show"
    trap-focus
    aria-role="dialog"
    scroll="keep"
    :width="1000"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form @submit.prevent="passes(save)">
        <div class="modal-card" style="width: 1000px">
          <header class="modal-card-head">
            <p class="modal-card-title">Copy Week</p>
          </header>
          <section class="modal-card-body" style="height: 600px">
            <BaseDatePicker v-model="newDate" label="New Start Date" />
          </section>
          <footer class="modal-card-foot" style="display: block">
            <button class="button" type="button" @click="closeModal">
              Cancel
            </button>
            <button class="button is-primary" type="button" @click="save">
              Copy
            </button>
          </footer>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import ScheduleApi from '@/api/schedules'
import { sortBy } from 'lodash'
import BaseDatePicker from '@/components/BaseDatePicker'

export default {
  name: 'CopyScheduleWeekModal',
  components: {
    BaseDatePicker
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: Date,
      default: null
    },
    endDate: {
      type: Date,
      default: null
    },
    channelId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      initialized: false,
      showModal: this.show,
      newDate: new Date()
    }
  },

  async created() {
    this.initialized = true
  },
  methods: {
    async save() {
      await ScheduleApi.copyWeek({
        channel_id: this.channelId,
        start_time: this.startDate,
        end_time: this.endDate,
        new_date: this.newDate
      })
      this.$buefy.toast.open({
        message: 'Week copied successfully!',
        position: 'is-top',
        type: 'is-success'
      })
      this.closeModal()
      this.$emit('refresh')
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    }
  }
}
</script>
